import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Nav from "react-bootstrap/Nav";
import MeusAnuncios from "../../components/meusAnunciosCard/meusAnunciosCard";
import MeusFavoritos from "./meusFavoritos";
import { Helmet } from "react-helmet";
import { sucessoToastify } from "../../shared/validacaoToastify";
import { ToastContainer } from "react-toastify";

export default function MeusAnunciosPage() {
  const navigate = useNavigate();
  const [ativoSelecionado, setAtivoSelecionado] = useState(true); 
  const [mostrarFavoritos, setMostrarFavoritos] = useState(false); 
  const location = useLocation();

  const handleNavSelection = (eventKey: string | null, event: any) => {
    if (eventKey === "/ativos") {
      setAtivoSelecionado(true);
      setMostrarFavoritos(false);
    } else if (eventKey === "/inativos") {
      setAtivoSelecionado(false);
      setMostrarFavoritos(false);
    } 
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const successMessage = searchParams.get("successMessage");
    if (successMessage) {
      sucessoToastify(successMessage);
      navigate("/milshop/usuario/meus-anuncios");
    }
  }, [location.search, navigate]);

  return (
    <>
    <Helmet>
      <title>Meus anúncios</title>
    </Helmet>
    <div className="container w-75" style={{ marginTop: '25px' }}>
      <div className="d-flex justify-content-between align-items-center">
        <h1 style={{ color: '#d49a08', fontSize: '1.2rem' }}>Meus Anúncios</h1>
        <a
          type="button"
          role="button"
          className="btn btn-outline-primary btn-sm"
          style={{ width: "100px", height: "auto" }}
          onClick={() => navigate("/milshop/anuncio/incluir")}
        >
          Incluir
        </a>
      </div>
      <Nav
        variant="underline"
        activeKey={ativoSelecionado ? "/ativos" : "/inativos"}
        onSelect={handleNavSelection}
      >
        <Nav.Item >
          <Nav.Link style={{ color: '#c4c4c4' }} eventKey="/ativos" href="#">
            Ativos
          </Nav.Link>
        </Nav.Item>
        <Nav.Item >
          <Nav.Link style={{ color: '#c4c4c4' }} eventKey="/inativos">Inativos</Nav.Link>
        </Nav.Item>
      </Nav>
     <MeusAnuncios ativos={ativoSelecionado} />
      <ToastContainer />
    </div>
  </>
  );
}
